import { useEffect } from "react";
import TaskHeatmap from "@components/admin-components/TaskHeatMap";
import DailyHeatmap from "@components/admin-components/StatsHeatMaps";
import "@css/Users.css";

// Для родителей → Статистика: годовые таблицы активности,
// перенесённые из профиля
const ParentsStats = () => {
    useEffect(() => {
        document.title = "Статистика";
    }, []);

    return (
        <div className="users">
            <h2>Статистика</h2>
            <TaskHeatmap />
            <DailyHeatmap />
        </div>
    );
};

export default ParentsStats;
